// extracted by mini-css-extract-plugin
export var actionButton = "_ie-0";
export var fileInput = "_ie-2";
export var paperclip = "_ie-1";